import linkLight from '../../../link/default/light';

const light = (params) => linkLight(params);

export default light;
